import styled from "@emotion/styled";
import { Checkbox, EditModal, Input, Title } from "@src/components";
import { IStateLandItem } from "@src/hooks/queries/useStateLand";
import { ConvertDateTime } from "@src/utils/dateUtil";
import { ConvertPrice } from "@src/utils/units";
import React, { Dispatch, SetStateAction } from "react";

interface UserRoadExpansionRefundModalProps {
    isShowRoadExpansionRefundModal: boolean;
    setIsShowModal: (isShow: boolean) => void;
    roadExpansionItem: IStateLandItem;
    setRefundRoadExpansionState: Dispatch<
        SetStateAction<{
            userNo: number;
            orderNo: number;
            amount: number;
            comments: string;
        }>
    >;
    refundRoadExpansionState: {
        userNo: number;
        orderNo: number;
        amount: number;
        comments: string;
    };
    setIsShowRoadExpansionRefundConfirmModal: Dispatch<SetStateAction<boolean>>;
}

const UserRoadExpansionRefundModal = ({
    isShowRoadExpansionRefundModal,
    setIsShowModal,
    roadExpansionItem,
    setRefundRoadExpansionState,
    refundRoadExpansionState,
    setIsShowRoadExpansionRefundConfirmModal,
}: UserRoadExpansionRefundModalProps) => {
    return (
        <>
            <EditModal
                isModalShow={isShowRoadExpansionRefundModal}
                buttonText="저장"
                handleBtnClick={() => {
                    setIsShowRoadExpansionRefundConfirmModal(true);
                    setIsShowModal(false);
                }}
                handleOpenModal={() => {
                    setIsShowModal(false);
                }}
                size="big"
                title="등기열람권 환불"
            >
                <StyledWrap>
                    <StyledContens>
                        <div className="row">
                            <div>
                                상품명 <span>{roadExpansionItem?.productName}</span>
                            </div>
                            <div>
                                결제액{" "}
                                <span>
                                    {roadExpansionItem?.paidPrice && ConvertPrice(roadExpansionItem?.paidPrice)}
                                </span>
                            </div>
                        </div>
                        <div className="row">
                            <div>
                                사용 여부
                                <span>{roadExpansionItem?.isUsed ? "O" : "X"}</span>
                            </div>
                            <div>
                                첫 사용일시
                                <span>
                                    {roadExpansionItem?.firstUsedAt && ConvertDateTime(roadExpansionItem?.firstUsedAt)}
                                </span>
                            </div>
                        </div>
                    </StyledContens>
                    <StyledRefundInfo>
                        <Title title="환불정보" />
                        <div className="row">
                            <div>
                                <span className="star">*</span>환불예정액{" "}
                                <Input
                                    errorMessage=""
                                    handleChange={(e) => {
                                        const onlyNumber = e.target.value.replace(/[^0-9]/g, "");
                                        setRefundRoadExpansionState({
                                            ...refundRoadExpansionState,
                                            amount: Number(onlyNumber),
                                        });
                                    }}
                                    onKeyDown={function noRefCheck() {}}
                                    placeholder="금액 입력"
                                    size="medium"
                                    type="text"
                                    value={refundRoadExpansionState.amount.toLocaleString() ?? ""}
                                />
                                <Checkbox
                                    defaultValue=""
                                    handleChange={(key, check) => {
                                        check &&
                                            roadExpansionItem?.paidPrice &&
                                            setRefundRoadExpansionState({
                                                ...refundRoadExpansionState,
                                                amount: roadExpansionItem?.paidPrice,
                                            });
                                    }}
                                    label="전액환불"
                                />
                            </div>
                        </div>
                        <StyledReasonWrapper>
                            <span>
                                <span className="essential">*</span>사유
                            </span>
                            <input
                                type="text"
                                placeholder="사유를 작성해 주세요"
                                onChange={(e: any) => {
                                    setRefundRoadExpansionState({
                                        ...refundRoadExpansionState,
                                        comments: e.target.value,
                                    });
                                }}
                                value={refundRoadExpansionState?.comments ?? ""}
                            />
                        </StyledReasonWrapper>
                    </StyledRefundInfo>
                </StyledWrap>
            </EditModal>
        </>
    );
};

export default UserRoadExpansionRefundModal;

const StyledWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 35px;
`;

const StyledContens = styled.div`
    display: flex;
    flex-direction: column;
    gap: 35px;
    & > .row {
        display: flex;
        & > div {
            width: 50%;
            & > span {
                margin-left: 15%;
            }
        }
    }
`;

const StyledRefundInfo = styled.div`
    margin-bottom: 25px;
    & > .row {
        display: flex;
        margin-top: 15px;
        & > div {
            width: 50%;
            display: flex;
            align-items: center;
            & > .star {
                color: #f45b5b;
                margin-left: 0;
            }
            & > span {
                margin-left: 15%;
            }
            & > input {
                margin-left: 20px;
                width: 50%;
                margin-right: 10px;
            }
        }
    }
`;

const StyledReasonWrapper = styled.div`
    position: absolute;
    bottom: 20px;
    width: 648px;
    height: 48px;
    display: flex;
    gap: 16px;
    align-items: center;
    & > span {
        font-weight: 400;
        font-size: 13px;
        width: 80px;
        .essential {
            color: #f45b5b;
        }
    }
    & > input {
        height: 100%;
        width: calc(100% - 296px);
        padding: 12px;
        font-weight: 400;
        font-size: 14px;
        line-height: 170%;
        color: #283237;
        border: 1px solid #e3e3e6;
        border-radius: 8px;
        outline: none;
    }
`;
